module.exports = __webpack_public_path__ + "2f64598d4c2987d9d7e9bc8a2af37c9e.jpg";